import { ZapIcon } from 'lucide-react';

function Home() {
	return (
		<div className="flex flex-col items-center justify-center h-full">
			<ZapIcon className="text-slate-300 dark:text-slate-700" size={256} />
		</div>
	);
}

export default Home;
